/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 27/9/2020
 */

import BaseObject from "@shared/BaseObject.js";

export default class TabItem extends BaseObject {

	label: string = null
	name: string = null
	disabled: boolean = false
	actionName: string = null
	component = null
	params = {}


	constructor(label: string, name: string, options = {}) {
		super();
		this.label = label;
		this.name = name;
		this.disabled = options.disabled || false
		this.actionName = options.actionName || null
		this.component = options.component
		this.params = options.params || {}
	}
}
